import { Routes } from '@angular/router';

export default [
    {
        path     : '',
        children:
        [
            {
                path: 'airfibre', loadChildren: () => import('app/modules/products/airfibre/airfibre.routes'),
                data: {
                    title: 'Supersonic Airfibre - Fast and Flexible Wireless Internet Solutions',
                    description: 'Discover Supersonic’s Airfibre for fast, reliable wireless internet solutions. Perfect for home or business, our Airfibre plans offer flexibility and high-speed connectivity.',
                    keywords: 'Airfibre South Africa, Supersonic Airfibre, wireless internet solutions, high-speed Airfibre plans, airfibre internet, airfibre internet. Airfibre pacakages, airfibre near me, airfibre south Africa, air fibre meaning, air fibre',

                    ogTitle: 'Supersonic Airfibre - Fast and Flexible Wireless Internet Solutions',
                    ogDescription: 'Discover Supersonic’s Airfibre for fast, reliable wireless internet solutions. Perfect for home or business, our Airfibre plans offer flexibility and high-speed connectivity.',
                    ogImage: 'https://supersonic.co.za/assets/images/logo/logo.svg',
                    ogUrl: 'https://supersonic.co.za/products/airfibre',
                    ogType: 'website',

                    twCard: 'summary_large_image',
                    twTitle: 'Supersonic Airfibre - Fast and Flexible Wireless Internet Solutions',
                    twDescription: 'Discover Supersonic’s Airfibre for fast, reliable wireless internet solutions. Perfect for home or business, our Airfibre plans offer flexibility and high-speed connectivity.',
                    twImage: 'https://supersonic.co.za/assets/images/logo/logo.svg',

                    canonical: 'https://supersonic.co.za/products/airfibre'
                }
            },
            {
                path: '5G', loadChildren: () => import('app/modules/products/5G/5G.routes'),
                data: {
                    title: 'Supersonic 5G Internet - Fast and Reliable 5G Connectivity Solutions',
                    description: 'Supersonic’s 5G internet offers fast and reliable connectivity with cutting-edge technology. Explore our 5G plans designed to keep you connected with high speeds and low latency.',
                    keywords: 'fibre internet South Africa, Supersonic fibre, high-speed fibre plans, reliable fibre connectivity, uncapped fibre South Africa, uncapped, download speed, supersonic fast internet, free to use router, fibre deals',

                    ogTitle: 'Supersonic 5G Internet - Fast and Reliable 5G Connectivity Solutions',
                    ogDescription: 'Supersonic’s 5G internet offers fast and reliable connectivity with cutting-edge technology. Explore our 5G plans designed to keep you connected with high speeds and low latency.',
                    ogImage: 'https://supersonic.co.za/assets/images/logo/logo.svg',
                    ogUrl: 'https://supersonic.co.za/products/5g',
                    ogType: 'website',

                    twCard: 'summary_large_image',
                    twTitle: 'Supersonic 5G Internet - Fast and Reliable 5G Connectivity Solutions',
                    twDescription: 'Supersonic’s 5G internet offers fast and reliable connectivity with cutting-edge technology. Explore our 5G plans designed to keep you connected with high speeds and low latency.',
                    twImage: 'https://supersonic.co.za/assets/images/logo/logo.svg',

                    canonical: 'https://supersonic.co.za/products/5g'
                }
            },
            {
                path: 'fibre', loadChildren: () => import('app/modules/products/fibre/fibre.routes'),
                data: {
                    title: 'Supersonic Fibre Internet - Ultra-Fast Uncapped Connectivity in South Africa',
                    description: 'Experience ultra-fast fibre internet with Supersonic. Our fibre plans provide high-speed, reliable connectivity for your home or business. Explore our uncapped fibre internet options today.',
                    keywords: 'fibre internet South Africa, Supersonic fibre, high-speed fibre plans, reliable fibre connectivity, uncapped fibre South Africa, uncapped, download speed, supersonic fast internet, free to use router, fibre deals',

                    ogTitle: 'Supersonic Fibre Internet - Ultra-Fast Uncapped Connectivity in South Africa',
                    ogDescription: 'Experience ultra-fast fibre internet with Supersonic. Our fibre plans provide high-speed, reliable connectivity for your home or business. Explore our uncapped fibre internet options today.',
                    ogImage: 'https://supersonic.co.za/assets/images/logo/logo.svg',
                    ogUrl: 'https://supersonic.co.za/products/fibre',
                    ogType: 'website',

                    twCard: 'summary_large_image',
                    twTitle: 'Supersonic Fibre Internet - Ultra-Fast Uncapped Connectivity in South Africa',
                    twDescription: 'Experience ultra-fast fibre internet with Supersonic. Our fibre plans provide high-speed, reliable connectivity for your home or business. Explore our uncapped fibre internet options today.',
                    twImage: 'https://supersonic.co.za/assets/images/logo/logo.svg',

                    canonical: 'https://supersonic.co.za/products/fibre'
                }},
            {
                path: 'fixed-lte', loadChildren: () => import('app/modules/products/fixed-lte/fixed-lte.routes'),
                data: {
                    title: 'Supersonic Fixed LTE - Reliable Internet for Home and Business',
                    description: 'Supersonic Fixed LTE offers a reliable internet connection for both home and business use. Enjoy high-speed internet with our fixed LTE plans tailored to your needs.',
                    keywords: 'fixed LTE South Africa, Supersonic Fixed LTE, reliable LTE internet, high-speed LTE plans, fixed lte deals, fixed lte router, fixed lte uncapped, fixed lte vs fibre, fixed lte vs lte, fixed lte inclusive data',

                    ogTitle: 'Supersonic Fixed LTE - Reliable Internet for Home and Business',
                    ogDescription: 'Supersonic Fixed LTE offers a reliable internet connection for both home and business use. Enjoy high-speed internet with our fixed LTE plans tailored to your needs.',
                    ogImage: 'https://supersonic.co.za/assets/images/logo/logo.svg',
                    ogUrl: 'https://supersonic.co.za/products/fixed-lte',
                    ogType: 'website',

                    twCard: 'summary_large_image',
                    twTitle: 'Supersonic Fixed LTE - Reliable Internet for Home and Business',
                    twDescription: 'Supersonic Fixed LTE offers a reliable internet connection for both home and business use. Enjoy high-speed internet with our fixed LTE plans tailored to your needs.',
                    twImage: 'https://supersonic.co.za/assets/images/logo/logo.svg',

                    canonical: 'https://supersonic.co.za/products/fixed-lte'
                }
            },
            // {path: 'catalog', loadChildren: () => import('app/modules/catalog/catalog.routes')},            
            // {path: 'products', loadChildren: () => import('app/modules/products/products.routes')},
        ]
    },
] as Routes;
